import React, { useEffect, useState } from 'react';
import './CallLogs.scss';
import { Loader, Table } from '../../../UiKit';
import { EmptyState } from '../../commons';
import { InvalidSearchImg } from '../../../images/images';
import { getTelecomLogs } from './utils';
import { valetModel } from '../../../api';

export const CallLogs = ({ orderId = null }) => {
  const [callLogsData, setCallLogsData] = useState(null);
  const [error, setError] = useState(null);

  const call_logs = callLogsData?.call_logs?.data?.length
    ? callLogsData.call_logs.data
    : null;

  useEffect(() => {
    const getCallLogsData = () => {
      const queryParams = {};
      queryParams['order_id'] = orderId;
      valetModel
        .getCallLogsDetails(queryParams)
        .then((response) => {
          if (!response || (response && response.isError === true))
            return setError(response);
          setCallLogsData(response.data);
        })
        .catch((error) => {
          setError(error);
          console.log('valet pop error', error);
        });
    };

    getCallLogsData();
  }, [orderId]);

  if (!callLogsData && !error) {
    return <Loader />;
  }
  if (error) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={error?.message || 'No data available!'}
        isPop={true}
      />
    );
  }

  return (
    <div className='modalContent'>
      {call_logs && (
        <div className='telecomLogsDetails'>
          <Table tableData={getTelecomLogs(call_logs)} />
        </div>
      )}

      {!call_logs && (
        <EmptyState
          img={InvalidSearchImg}
          heading='No calls have been made yet'
          isPop={true}
        />
      )}
    </div>
  );
};
